import React from "react";
import {
  Card,
  CardContent,
  CardProps,
  CircularProgress,
} from "@material-ui/core";

export interface CardLoadingProps extends CardProps {
  loading: boolean;
}

export const CardLoading: React.FC<CardLoadingProps> = ({
  loading,
  children,
  ...props
}) => {
  return (
    <Card {...props} style={{ width: "200px", ...props.style }}>
      <CardContent>
        {loading ? (
          <div style={{ textAlign: "center" }}>
            <CircularProgress />
          </div>
        ) : (
          children
        )}
      </CardContent>
    </Card>
  );
};
